import identityIcon from "@/libs/identityIcon";
export default {
  name: "LineOrgTag",
  props: {
    list: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      identityIcon
    };
  }
};